import { Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import CKEditor from 'ckeditor4-react';
import { Labeled } from 'react-admin';
import React, { useCallback, useEffect, useState } from 'react';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import PreviewEmailApi from '../../core/apis/PreviewEmailApi';
import CircularProgress from '@material-ui/core/CircularProgress';
import RichTextInput from '../../core/components/inputs/RichTextInput';

/**
 * Email preview dialog for distribution list
 */
const EmailPreviewDialog = ({
  showDialog,
  handleDialogToggle,
  values,
  record
}) => {
  const [substitutedSubject, setSubstitutedSubject] = useState();
  const [substitutedBody, setSubstitutedBody] = useState();
  // Perform the variable substitution by calling the API
  const [loading, setLoading] = useState(false);
  const previewItem = useCallback(
    async item => {
      if (item) {
        setLoading(true);
        const emailToSubstitute = {
          subject: values.subject,
          msgBody: values.msgBody,
          userId: item.userId,
          userEmail: item.email,
          testEmail: false
        };

        const data = await PreviewEmailApi.contactPreview(emailToSubstitute);

        setSubstitutedSubject(data.subject);
        setSubstitutedBody(data.msgBody);
        setLoading(false);
      }
    },
    [values]
  );

  // Preview mail
  useEffect(() => {
    if (showDialog) {
      previewItem(record);
    }
  }, [previewItem, record, showDialog]);

  return (
    <Dialog
      fullWidth
      open={showDialog}
      aria-label="Preview Email"
      maxWidth="md"
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return null;
        handleDialogToggle();
      }}
    >
      <DialogTitleWithCloseButton onClose={handleDialogToggle}>
        Preview Email
      </DialogTitleWithCloseButton>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <TextField value={substitutedSubject} label="Subject:" disabled />
          </Grid>

          <Grid item xs={12}>
            <Labeled label="Body:">
              <CKEditor
                data={substitutedBody}
                readOnly
                id="email-body"
                config={RichTextInput.defaultProps.editorConfig}
              />
            </Labeled>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <div style={{ flexGrow: 1 }}>
          {`${record.firstName} ${record.lastName}`}
        </div>
        {loading && <CircularProgress size={25} thickness={2} />}
      </DialogActions>
    </Dialog>
  );
};

export default EmailPreviewDialog;
